module.exports = __webpack_public_path__ + "img/performance-school-icon3.a67a9558.png";